import { render, staticRenderFns } from "./MinimalBgHeaderLayout.vue?vue&type=template&id=13286411&"
import script from "./MinimalBgHeaderLayout.vue?vue&type=script&lang=js&"
export * from "./MinimalBgHeaderLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports